// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1R183","footer":"ModalInfo_footer__1rzXi"};